
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/macromill-designsystem",
      function () {
        return require("private-next-pages/cases/macromill-designsystem/index.tsx");
      }
    ]);
  